import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginForm from './LoginForm';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  // Afficher un loader pendant la vérification de l'authentification
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Si l'utilisateur n'est pas authentifié, afficher le formulaire de connexion
  if (!isAuthenticated) {
    return <LoginForm />;
  }

  // Si un rôle spécifique est requis, vérifier que l'utilisateur l'a
  if (requiredRole && user && !user.roles.includes(requiredRole)) {
    return (
      <div className="access-denied-container">
        <div className="access-denied-card">
          <div className="access-denied-icon">🚫</div>
          <h2 className="access-denied-title">Accès refusé</h2>
          <p className="access-denied-message">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          </p>
          <div className="access-denied-role">
            Rôle requis : {requiredRole}
          </div>
        </div>
      </div>
    );
  }

  // Si tout est OK, afficher le contenu protégé
  return <>{children}</>;
};

export default ProtectedRoute;
